import styled from 'styled-components';
import {
  BORDER_RADIUS,
  GRAY_DARKER,
  GRAY_MEDIUM,
  FONT_SIZE_5,
  FONT_WEIGHT_NORMAL,
  FONT_SIZE_6,
  FONT_WEIGHT_BOLD,
  MAIN_COLOR,
} from '../../../styles/variables';
import { fontStyle, flexPosition } from '../../../styles/mixins';

export const Container = styled.div`
  background-color: ${GRAY_DARKER};
  width: 100%;
  height: 100%;
`;

export const MenuResume = styled.div``;

export const Content = styled.div`
  padding: 30px;
  width: 100%;
  padding-top: 95px;
  ${props =>
    props.flexColumn
      ? `
    ${flexPosition({ justify: 'space-between' })}
    flex-direction: column;
  `
      : null}
  height: 100%;
`;

export const Title = styled.h2`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_NORMAL)}
  margin: 0;
  ${props => props.style}
`;

export const MenuList = styled.ul`
  margin-top: 40px;
  padding: 0;
  margin-bottom: 0;
  max-height: 320px;
  overflow-y: auto;
`;

export const MenuItem = styled.li`
  margin-bottom: 25px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const MarketplacesName = styled.h3`
  ${fontStyle('#FFF', FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin-bottom: 5px;
  text-transform: capitalize;
`;

export const MenuType = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_6, FONT_WEIGHT_NORMAL)}
  margin: 0;
`;

export const ButtonContainer = styled.div`
  margin-top: 30px;
  ${flexPosition({ align: 'center', justify: 'flex-end' })}
`;

export const Button = styled.button`
  ${fontStyle('#FFF', FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  background-color: ${MAIN_COLOR};
  border: none;
  border-radius: ${BORDER_RADIUS};
  height: 45px;
  width: 120px;
`;



// WEBPACK FOOTER //
// ./src/components/CreateMenuModal/CreateMenuHelper/style.js